import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface IProps {
  backlabel?: string;
  disabled?: boolean;
  backPath?: string;
}

const BackButton = ({ backlabel, disabled, backPath }: IProps) => {
    
    const navigate = useNavigate();
    const handleClose = () => {

        if(backPath) {
            navigate(backPath);
        }
        else {
            navigate(-1);
        }

    };

    const back = backlabel ? backlabel : 'Back';

    return (
        <Button 
            disabled={disabled} 
            onClick={handleClose}
            variant="outlined"
            color="secondary"
        >
            {" " + back + " "}
        </Button>
    );
}

export default BackButton;